module.exports = __webpack_public_path__ + "static/media/sustainability.9b74e9a7.png";